<template>
  <table>
    <tbody>
      <tr>
        <td>
          <div style="width: 100px;">
            <div v-bind:style="{height: timeRulerHeight + 'px'}">
            </div>
            <div v-bind:style="rowHeadStyle(null)">
              未割当
            </div>
            <div
              v-for="shift in shifts"
              :key="shift.id"
              v-bind:style="rowHeadStyle(shift)">
              {{ shift._embedded.staff.name }}
            </div>
          </div>
        </td>
        <td>
          <div>
            <reservation-table-row
              v-bind="rowAttrs"
              :height="timeRulerHeight">
              <div slot="body" slot-scope="props">
                <reservation-table-time-ruler
                  v-for="tick in ticks"
                  :tick="tick"
                  v-bind="rowAttrs"
                  :height="timeRulerHeight"
                  :key="tick.toISOString()">
                </reservation-table-time-ruler>
              </div>
            </reservation-table-row>
            <reservation-table-row
              @clickCell="createReservation(null, $event)"
              :reservations="assignedReservations(null)"
              v-bind="rowAttrs"
              :height="rowHeight(null)">
              <reservation-box
                @click.native="clickReservation(reservation.pk)"
                :slot="reservation.pk"
                v-for="reservation in assignedReservations(null)"
                :reservation="reservation"
                :key="reservation.pk" />
            </reservation-table-row>
            <reservation-table-row
              @clickCell="createReservation(shift.id, $event)"
              v-for="shift in shifts"
              :key="shift.id"
              :reservations="assignedReservations(shift)"
              v-bind="rowAttrs"
              :height="rowHeight(shift)">
              <reservation-box
                @click.native="clickReservation(reservation.pk)"
                :slot="reservation.pk"
                v-for="reservation in assignedReservations(shift)"
                :reservation="reservation"
                :key="reservation.pk" />
            </reservation-table-row>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Moment from 'moment'
import { extendMoment } from 'moment-range'

import ReservationTableRow from './Row'
import ReservationBox from './Box'
import ReservationTableTimeRuler from './TimeRuler'

const moment = extendMoment(Moment)

export default {
  name: 'ReservationTable',
  props: {
    shop: {
      type: Object,
      required: true,
    },
    reservations: {
      type: Array,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  watch: {
    shop () {
      this.fetchData()
    },
    date () {
      console.log('date change')
      this.fetchData()
    },
  },
  data () {
    return {
      pxPerMinute: 3,
      tickDuration: 10,
      timeRulerHeight: 30,
      reservationHeight: 120,
      reservationBoxHeight: 120,
      reservationBoxMarginTop: 10,
      reservationBoxMarginBottom: 10,
      isLoading: false,
      shifts: [],
    }
  },
  computed: {
    startAt () {
      return moment(this.date).hours(9).minutes(0).seconds(0).millisecond(0)
    },
    endAt () {
      return moment(this.date).hours(22).minutes(0).seconds(0).millisecond(0)
    },
    ticks () {
      let range = moment.range(this.startAt, this.endAt)
      let ret = []
      for (let tick of range.by('minutes', {step: this.tickDuration})) {
        ret.push(tick)
      }
      return ret
    },
    trackHeight () {
      return this.reservationBoxHeight + this.reservationBoxMarginTop + this.reservationBoxMarginBottom
    },
    rowAttrs () {
      return {
        ticks: this.ticks,
        startAt: this.startAt,
        endAt: this.endAt,
        tickDuration: this.tickDuration,
        unitRowHeight: 30,
        reservationBoxHeight: this.reservationBoxHeight,
        reservationBoxMarginTop: this.reservationBoxMarginTop,
        reservationBoxMarginBottom: this.reservationBoxMarginBottom,
        trackHeight: this.trackHeight,
        pxPerCell: this.pxPerMinute * this.tickDuration,
        pxPerMinute: this.pxPerMinute,
        tickBorderWidth: 2,
        borderTopWidth: 2,
        borderBottomWidth: 2,
        borderColorDefault: '#dddddd',
        backgroundColorFocused: '#eeeeee',
      }
    },
  },
  methods: {
    fetchData () {
      this.fetchShiftData()
    },
    fetchShiftData () {
      if (!this.shop.pk) {
        return
      }
      this.isLoading = true
      this.$request.shifts.list(this.shop.pk, this.date).then(res => {
        this.shifts = res.body.results
      }).finally(() => {
        this.isLoading = false
      })
    },
    createReservation (shift, tick) {
      this.$emit('createReservation', tick, shift)
    },
    clickReservation (reservationId) {
      this.$emit('editReservation', reservationId)
    },
    assignedReservations (shift) {
      const staff = shift ? shift._embedded.staff.pk : null
      let tmp = this.reservations.filter(x => x.attendedStaff === staff)
      tmp.map(x => {
        x.range = moment.range(x.startAt, x.endAt)
      })
      let ret = []
      tmp.map(r => {
        for (let track = 0; true; track++) {
          const isOverlapped = ret.find(_r => {
            return _r.track === track && _r.range.overlaps(r.range)
          })
          if (!isOverlapped) {
            ret.push(Object.assign({}, r, {track: track}))
            break
          }
        }
      })
      return ret
    },
    rowHeight (shift) {
      return this.trackLength(shift) * this.trackHeight
    },
    trackLength (shift) {
      // TODO:
      let tracks = this.assignedReservations(shift).map(x => x.track)
      if (!tracks.length) {
        return 1
      }
      let ret = Math.max.apply(null, tracks) + 1
      return ret
    },
    rowHeadStyle (shift) {
      return {
        height: this.rowHeight(shift) + 'px',
        'line-height': this.rowHeight(shift) + 'px',
      }
    },
    onScroll (event) {
      console.log(event)
    },
  },
  mounted () {
    console.log('test')
    this.fetchData()
  },
  components: {
    ReservationTableRow,
    ReservationBox,
    ReservationTableTimeRuler,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Table/Index.vue